export default __webpack_public_path__ + "static/media/icon-insights-performance-positive-reviews.00a0a204.svg";